import { withDynamicNamespaces } from "@components/hoc/withDynamicNamespaces"
import { IMarketSortOrder } from "@redux/usecases/marketplace"
import { NamespaceShortcut, useDynamicTranslation } from "@services/i18n"
import { StringBasedStringArray } from "@services/util"

import ActionIcon from "../ActionIcon"
import DropdownComponent from "../DropdownComponent"
import Icon from "../Icon"

const usedNamespaces: NamespaceShortcut[] = ["common"]

interface IProps {
  sortingOptions: StringBasedStringArray
  onChange: (newSortOrder: IMarketSortOrder, newSortBy: string) => void
  sortBy: string
  sortOrder: IMarketSortOrder
}

const OrderByComponent = (props: IProps): JSX.Element => {
  const t = useDynamicTranslation()
  const {
    sortingOptions,
    onChange,
    sortBy,
    sortOrder,
  } = props

  return <div className="sortby-filter">
    <ActionIcon
      title={t('common', `form.marketplace.sort.label.${sortOrder}`)}
      onclick={() => {
        const newSortOrder =
          sortOrder === IMarketSortOrder.DESC
            ? IMarketSortOrder.ASC
            : IMarketSortOrder.DESC
        onChange(newSortOrder, sortBy)
      }}
      icon={
        sortOrder === IMarketSortOrder.DESC
          ? "sort-descending"
          : "sort-ascending"
      }
    />
    <DropdownComponent
      light
      button={
        <span
          className="actionicon"
          title={t('common', "form.marketplace.sort.hover")}
        >
          <span>
            {sortingOptions[sortBy]}
          </span>
          <Icon
            name={"chevron-down"}
            size={25}
            title={t('common', "form.marketplace.sort.hover")}
          />
        </span>
      }
    >
      {Object.keys(sortingOptions).map((item: string) =>
        <a
          key={item}
          onClick={() => {
            onChange(sortOrder, item)
          }}
        >
          {sortingOptions[item]}
        </a>
      )}
    </DropdownComponent>
  </div>
}

export default withDynamicNamespaces<IProps>(OrderByComponent, usedNamespaces)